import { render, staticRenderFns } from "./HorseInformation.vue?vue&type=template&id=4729e7b2&"
import script from "./HorseInformation.vue?vue&type=script&lang=js&"
export * from "./HorseInformation.vue?vue&type=script&lang=js&"
import style0 from "./HorseInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports